export default {
	APP_KEY: 'vwstudio',

}